import {
    FeedbackPrivacy,
    revieweeLaunchedCopy,
    type FeedbackPrivacyCopyKey,
} from '@/constants/review/FeedbackPrivacy';

/** Who the respondent of a 360 is to its results, as the server tells it. */
export interface RespondentStanding {
    /** The person evaluated launched the 360 and reads its results. */
    launchedByReviewee?: boolean;
    /** The respondent reads the results themselves, as the 360's launcher or the evaluated person's manager. */
    readsResults?: boolean;
}

interface AnonymousRespondentCopy {
    /** What stays hidden. */
    hidden: FeedbackPrivacyCopyKey;
    /** What the person evaluated will see. */
    revieweeSentence: FeedbackPrivacyCopyKey;
    /** When the answers show, and how. */
    conditions: FeedbackPrivacyCopyKey[];
}

const REVIEWEE_SEES_RESULTS = revieweeLaunchedCopy(FeedbackPrivacy.ANONYMOUS);
const MIXED_WITH_OTHERS: FeedbackPrivacyCopyKey =
    'answer.feedbackPrivacy.anonymous.mixedWithOthers';

/**
 * The one place the promises told to an anonymous 360's respondent are chosen, for the privacy screen and the details
 * behind the reminder alike. A respondent who reads the results is not promised that their name stays from readers,
 * and nobody is told the person evaluated sees nothing when that person launched the 360.
 */
export const anonymousRespondentCopy = ({
    launchedByReviewee = false,
    readsResults = false,
}: RespondentStanding): AnonymousRespondentCopy => ({
    hidden: readsResults ? MIXED_WITH_OTHERS : 'answer.feedbackPrivacy.anonymous.hidden',
    revieweeSentence: launchedByReviewee
        ? REVIEWEE_SEES_RESULTS
        : 'answer.feedbackPrivacy.anonymous.revieweeSeesNoAnswer',
    conditions: [
        'answer.feedbackPrivacy.anonymous.threshold',
        'answer.feedbackPrivacy.anonymous.commentsOrder',
    ],
});
